import React, { useState, useEffect } from "react";
import { useChat } from "../contexts/ChatProvider";
import {
  MainContainer,
  MessageContainer,
  MessageHeader,
} from "@minchat/react-chat-ui";
import MessageInput from './message-input';
import ChatContainerFullScreen from "./message/ChatContainerFullScreen";
import CrossIcon from './icons/CrossIcon';
import ExitFullScreenIcon from "./icons/ExitFullscreenIcon";

export const FullScreenWidget = ({ remoteName = "", onSend, onScreenMinimize}) => {
  const { hide, theme, colorSet, loading, header, showTypingIndicator, exitFullScreen, isMobile } = useChat();
  const [ deviceWidth, setDeviceWidth ] = useState();
  useEffect(() => {
      function handleResize() {
        setDeviceWidth(window.outerWidth);
      }
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  const HandleExitFullScreen = () => {
    exitFullScreen();
    onScreenMinimize();
  }

  return (
    <div style={{width: "100vw", height: "100%"}}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0.75rem 1.5rem",
        backgroundColor: "#e5e7eb",
        position: "sticky",
        top: 0,
        zIndex: 100
      }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", padding: "0 2% 0 2%", width: '100%' }}>
          <p id="ChatBotTitle" style={{ paddingLeft: "15px", fontSize: "20px", fontWeight: "bold" }}>
            {header}
          </p>
          <div style={{ display: "flex", justifyContent: "start", gap: "15px" }}>
            <span
              className="header-action"
              onClick={() => { hide() }}
              style={{ "--theme-color": theme, cursor: 'pointer', borderRadius: '50%', height: "24px", width: "24px" }}
            >
              <CrossIcon color={colorSet["--message-header-text-color"] ?? "black"} />
            </span>
            {!isMobile && (<span
              className="header-action"
              onClick={HandleExitFullScreen}
              style={{ "--theme-color": theme, cursor: 'pointer', borderRadius: '50%', height: "24px", width: "24px" }}
            >
              <ExitFullScreenIcon color={colorSet["--message-header-text-color"] ?? "black"} />
            </span>)}
          </div>
        </div>
      </div>
      <MainContainer>
        <MessageContainer>
          <div
            style={{
              height: "90%", width: "100%", backgroundColor: "white", alignItems: 'center'
            }}
          >
              <ChatContainerFullScreen
                remoteName={remoteName}
                loading={loading}
                showTypingIndicator={showTypingIndicator}
                deviceWidth={deviceWidth}
                onSendMessage={onSend}
              />
            </div>
        </MessageContainer>
      </MainContainer>
      <div style={{
        position: "sticky", 
        bottom: 20, 
        background: "white", 
        zIndex:100, 
        marginTop: "5px",
        maxWidth: deviceWidth <= 1024 ? (deviceWidth-200)+"px" : "940px",
        width: deviceWidth <= 1024 ? (deviceWidth-200)+"px" : "clamp(810px, 60vw, 940px)",
        margin:"auto"
      }}>
        <MessageInput 
            placeholder="ここにメッセージを入力してください"
            isFullScreen={true}
            onSendMessage={onSend}
            showAttachButton={false}
            disabled={showTypingIndicator}
        />
        <p style={{textAlign: "center", margin: "auto", fontSize: "12px", paddingTop: "5px"}}>Enterで送信 • Shift+Enterで改行</p>
      </div>
    </div>
  )
}